<template slot-scope="scope">
  <!-- 协议弹窗 -->
      <dialogModel
        title="协议"
        :visible="dialogAgr"
        :footer="false"
        @handleClose="handleClose"
      >
        <div class="checkbox-box firm-clickable" @click.stop="">
          <el-checkbox v-model="checked"></el-checkbox>
        </div>
      </dialogModel>
</template>

<script>
export default {
  // 接收父组件传的参数

  props: {
    dialogAgr: {}, // 弹窗开关
    agreement: {}, // 区分协议类型
  },
  components: {},
  data() {
    return {
      checked: false,
    };
  },
  computed: {},
  created() {},
  methods: {
    // 取消关闭弹窗
    handleClose() {
      this.$emit("handleClose");
    },
    // 确认
    // handleUnderstand() {
    //   if (this.checked == true) {
    //     this.$emit("handleUnderstand", this.checked);
    //   }
    // },
  },
};
</script>

<style scoped lang="less">
.checkbox-box {
  width: 100%;
  min-height: 100px;
  padding-top: 0px;
  margin: 20px 0px;
  display: flex;
  flex-direction: column;
}
// 底部按钮
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}
</style>
